import React from "react";

import ReportContext from "contexts/ReportContext";

import ReportMenu from "components/features/ReportMenu";
import ReportBody from "components/features/ReportBody";

function Sales() {
	const types = [
		{ route: "sales", label: "Sales" },
		{ route: "salesreturn", label: "Sales Return" },
	];
	return (
		<ReportContext type="sales" types={types}>
			<ReportMenu label="Sales" />
			<ReportBody />
		</ReportContext>
	);
}

export default Sales;
